interface IWhiteLabelEnabler {
  enable: boolean;
}
interface IWhiteLabelGeneral {
  supportEmail: string;
  supportCenterUrl: string;
  knowledgeBaseUrl: string;
}
interface IWhiteLabelData {
  name: string;
  secondName: string;
  billing: IWhiteLabelEnabler;
  onBoard: IWhiteLabelEnabler;
  management: IWhiteLabelEnabler;
  ssoSW: IWhiteLabelEnabler;
  support: IWhiteLabelEnabler;
  dnsFiltering: IWhiteLabelEnabler;
  splunkIntegration: IWhiteLabelEnabler;
  azureSentinelIntegration: IWhiteLabelEnabler;
  amazonS3Integration: IWhiteLabelEnabler;
  killSwitch: IWhiteLabelEnabler;
  auth2: IWhiteLabelEnabler;
  general: IWhiteLabelGeneral;
}

const WHITE_LABEL_DATA: IWhiteLabelData = {
  name: "perimeter81",
  secondName: "Check Point SASE",
  billing: {
    enable: true,
  },
  onBoard: {
    enable: true,
  },
  management: {
    enable: true,
  },
  ssoSW: {
    enable: false,
  },
  support: {
    enable: true,
  },
  dnsFiltering: {
    enable: true,
  },
  splunkIntegration: {
    enable: true,
  },
  azureSentinelIntegration: {
    enable: true,
  },
  amazonS3Integration: {
    enable: true,
  },
  killSwitch: {
    enable: true,
  },
  auth2: {
    enable: true,
  },
  general: {
    supportEmail: "sase-support@checkpoint.com",
    supportCenterUrl: "https://supportcenter.checkpoint.com/",
    knowledgeBaseUrl: "https://sc1.checkpoint.com/documents/Infinity_Portal/WebAdminGuides/EN/SASE-Admin-Guide/Content/Topics-SASE-AG/Introduction/Introduction.htm",
  },
};

export function useWhitelabel(): IWhiteLabelData {
  return WHITE_LABEL_DATA;
}
